import { createFileRoute } from '@tanstack/react-router'
import { ChatsView } from '@/components/views/ChatsView'

export const Route = createFileRoute('/_auth/chats')({
  beforeLoad: () => ({ title: 'Chats' }),
  component: ChatsView,
})
